module.exports = __webpack_public_path__ + "static/conference-94b62f51aa1ec91d81fe4c2b3f9149a3.svg";